const state = {
  cartIds: []
}

const mutations = {
  SET_CART_IDS: (state, ids) => {
    state.cartIds = ids
  }
}

const actions = {
  setCartIds({commit}, ids) {
    commit('SET_CART_IDS', ids)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
